import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionImageEnhancer from '../../../redux/action/FJActionImageEnhancer';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon';
import FJUtil from '../../../util/FJUtil';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
import FJImageInput from '../../../common/components/FJImageInput/FJImageInput.jsx';
import {
    UPLOAD_FILE_TYPE_NO_GIF,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../config/dataConfig/FJGenerateData.js';

const FJImageEnhancerInputContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const uploadImages = files => {
        dispatch(FJActionImageEnhancer.uploadImagesAction(files));
    };

    const _openMediaLibrary = () => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    isMultiple: true,
                    maxMediaNum: 10,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode: UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    acceptTypeNoTranscode: UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['IMAGE'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };
    const isDisabled = FJUtil.isGeneratingStatus(taskStatus);
    return (
        <FJImageInput
            isDraggingFile={isDraggingFile}
            openMediaLibrary={_openMediaLibrary}
            uploadImg={uploadImages}
            setIsDraggingFile={_setIsDraggingFile}
            disable={isDisabled}
            isMultiple={true}
            acceptFile={UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
        />
    );
};
export default FJImageEnhancerInputContainer;
